//PUCHDBPROVIDER LOGIN WITH API
//2022 hanya pakai LOKAL

import React, { useContext, useEffect, useState } from "react";

import PouchDB from "pouchdb-browser";
import PouchDBFind from "pouchdb-find";
import PouchDBAuth from "pouchdb-authentication";
import { remote, local } from "../../config/db";
// import { useSnackbar } from 'notistack';

//localforage
//import localforage from 'localforage';

// Firebase
import * as firebase from "firebase";
import "firebase/messaging";

import axios from "axios";

PouchDB.plugin(PouchDBFind);
PouchDB.plugin(PouchDBAuth, { skip_setup: true });

const API_URL = process.env.REACT_APP_API_DEVELOPMENT_URL;
const USER_KEY_AUTH = process.env.REACT_APP_USER_KEY_AUTH;

// db 05Des2019
export const dataBkkbn = {
  local: new PouchDB(local.data_bkkbn, {
    fetch: function (url, opts) {
      // opts.headers.set('user_key', '3086981474597c8256da7c6206e3e6fc');
      // opts.headers.set('user_key', '1d1d2cded224a68cfce559f1401d65ac');
      // opts.headers.set('Authorization', '1d1d2cded224a68cfce559f1401d65ac');
      // return PouchDB.fetch(url, opts);
      return PouchDB.fetch(url);
    },
  }),

  remote: new PouchDB(remote.data_bkkbn, {
    fetch: function (url, opts) {
      // opts.headers.set('user_key', '3086981474597c8256da7c6206e3e6fc');
      // opts.headers.set('user_key', '1d1d2cded224a68cfce559f1401d65ac');
      // opts.headers.set('Authorization', '1d1d2cded224a68cfce559f1401d65ac');
      // return PouchDB.fetch(url, opts);
      return PouchDB.fetch(url);
      // return PouchDB.fetch(url.substring(0,url.length-1)+'?user_key=3086981474597c8256da7c6206e3e6fc', opts);
    },
  }),
};

// db
export const dataPK = {
  local: new PouchDB(local.data_pk),
  remote: new PouchDB(remote.data_pk),
};

export const dataKK = {
  local: new PouchDB(local.data_kk),
  remote: new PouchDB(remote.data_kk),
};

export const dataKB = {
  local: new PouchDB(local.data_kb),
  remote: new PouchDB(remote.data_kb),
};

export const dataRekap = {
  local: new PouchDB(local.data_rekap),
  remote: new PouchDB(remote.data_rekap),
};

export const dataFrontend = new PouchDB("frontend");

const PouchDBContext = React.createContext();

//create indexes 05Des2019

dataBkkbn.local.createIndex({
  index: {
    fields: ["No_KK", "status_sensus", "flag_retrieve"],
  },
});

// //create indexes
dataKK.local.createIndex({
  index: {
    fields: ["user_name", "no_kk"],
  },
});
dataKB.local.createIndex({
  index: {
    fields: ["No_KK"],
  },
});

dataPK.local.createIndex({
  index: {
    fields: ["No_KK"],
  },
});

dataRekap.local.createIndex({
  index: {
    fields: ["id"],
  },
});
// create filter
(async () => {
  try {
    await dataBkkbn.local.put({
      _id: "_design/app",
      filters: {
        by_user_name:
          "function(doc, req) {return doc.user_name === req.query.user_name;}",
      },
    });

    await dataKK.local.put({
      _id: "_design/app",
      filters: {
        by_user_name:
          "function(doc, req) {return doc.user_name === req.query.user_name;}",
      },
    });

    await dataPK.local.put({
      _id: "_design/app",
      filters: {
        by_user_name:
          "function(doc, req) {return doc.user_name === req.query.user_name;}",
      },
    });

    await dataKB.local.put({
      _id: "_design/app",
      filters: {
        by_user_name:
          "function(doc, req) {return doc.user_name === req.query.user_name;}",
      },
    });

    await dataRekap.local.put({
      _id: "_design/app",
      filters: {
        by_user_name:
          "function(doc, req) {return doc.user_name === req.query.user_name;}",
      },
    });
  } catch (e) {}
})();

export function usePouchDB() {
  return useContext(PouchDBContext);
}

function PouchDBProvider(props) {
  const [user, setUser] = useState({
    isLoggedIn: false,
    loading: true,
  });

  const [auth, setAuth] = useState({});

  useEffect(() => {
    const auth = new PouchDB(remote.users);
    setAuth(auth);
    const getSession = async () => {
      setUser((user) => ({ ...user, loading: true }));

      try {
        //step 2 login if sudah login
        const localsession = await dataFrontend.get("auth");

        setUser(localsession.authData);

        try {
          const newData = await getData(
            localsession.authData.name,
            localsession.authData.id
          );
          // console.log(newData, "<<<===== NEWDATA");
          const userCtx = {
            name: newData.userProfile.nameProses,
            roles: newData.userProfile.roles,
            id: newData.id,
            ipAddress: newData.ipAddress,
            jsessionid: newData.jsessionid,
            flagFirstLogin: newData.flagFirstLogin,
          };

          const metadata = newData.userProfile;

          setUser((user) => ({
            ...user,
            ...userCtx,
            isLoggedIn: true,
            metadata,
          }));

          const authData = {
            ...userCtx,
            isLoggedIn: true,
            metadata,
          };

          try {
            await dataFrontend.put({
              _id: "auth",
              authData,
            });
          } catch (error) {
            await dataFrontend.remove(localsession);
            await dataFrontend.put({
              _id: "auth",
              authData,
            });
          }
        } catch (error) {
          //console.log("eror getdata ", error)
        }
      } catch (e) {
        setUser({
          isLoggedIn: false,
          loading: false,
        });
      }

      setUser((user) => ({ ...user, loading: false }));
    };

    getSession();
  }, [user.isLoggedIn]);

  const getData = async (name, id) => {
    // console.log(name, "<<<===== NAME");
    try {
      const data = await axios.get(
        `${API_URL}/auth/getUser?name=${name}&q=${id}&user_key=5848e56474b2baefc07afe94bff01afa`,
        {
          headers: {
            withCredentials: true,
            "Content-Type": "application/json",
            // user_key: USER_KEY_AUTH
            Authorization: "Basic YWRtaW46cGFzc3dvcmQ=",
          },
        }
      );

      return data.data;
    } catch (error) {
      console.log(error);
    }
  };

  const logoutAndClearLocal = async () => {
    try {
      const localsession = await dataFrontend.get("auth");
      let userCtx = {};
      let metadata = {};

      dataFrontend.remove(localsession);
      localStorage.removeItem("notification-token");
      firebase.messaging().deleteToken();
      localStorage.removeItem("db_name");
      localStorage.removeItem("remote_base");
      localStorage.removeItem("opr");
      localStorage.removeItem("rw");

      // console.log("remove datafrontend, localstorage, and firebase token run");

      setUser((user) => ({ ...user, userCtx, isLoggedIn: false, metadata }));

      // console.log("Logout with hout API success");

      // axios.post(`${API_URL}/auth/signout/${localsession.authData.name}?q=${localsession.authData.id}`,{
      //     headers: {
      //     'Content-Type': 'application/json'
      //     }
      // }).then((res) => {

      //     if (res.status == "200") {

      //         try {

      //             dataFrontend.remove(localsession);
      //             localStorage.removeItem('notification-token')
      //             firebase.messaging().deleteToken();
      //             localStorage.removeItem("db_name");
      //             localStorage.removeItem("remote_base");

      //             console.log("remove datafrontend, localstorage, and firebase token run")

      //         } catch (error) {
      //             console.log("remove datafrontend error => ", error)
      //         }

      //         setUser(user => ({ ...user, userCtx, isLoggedIn: false, metadata }))

      //         console.log("Logout with API success")
      //     }
      // }).catch(function(error) {

      //     console.log("Err => ", error)

      //     try {

      //         dataFrontend.remove(localsession);
      //         localStorage.removeItem('notification-token')
      //         firebase.messaging().deleteToken();
      //         localStorage.removeItem("db_name");
      //         localStorage.removeItem("remote_base");

      //         console.log("remove datafrontend, localstorage, and firebase token run")

      //     } catch (error) {
      //         console.log("remove datafrontend error => ", error)
      //     }

      //     setUser(user => ({ ...user, userCtx, isLoggedIn: false, metadata }))

      //     console.log("Logout with hout API success")
      // })
    } catch (e) {
      console.log(JSON.stringify(e));
      if (e.name === "not_found") {
        setUser((user) => ({ ...user, isLoggedIn: false }));
      }
    }
  };

  return (
    <PouchDBContext.Provider
      value={{
        logoutAndClearLocal,
        auth,
        user,
        setUser,
        dataKK,
        dataPK,
        dataKB,
        dataBkkbn,
        dataRekap,
        PouchDB,
      }}
    >
      {props.children}
    </PouchDBContext.Provider>
  );
}

export default PouchDBProvider;
